// Импорт rate limiter
import rateLimiter from './rateLimiter';
import chatService from './chatService';

// API конфигурация
const API_BASE = "https://vless-balancer.ru/rpc/get_new_sub";


// Получение IP адреса (упрощенная версия)
const getClientIP = () => {
  // Используем стабильный идентификатор из rateLimiter
  return rateLimiter.getClientID();
};

// API функция для проверки заказа
export const checkOrder = async (v_o_id, existingHistory = [], email = '') => {
  try {
    console.log('[checkOrder] Начало проверки заказа:', { 
      orderNumber: v_o_id, 
      historyCount: existingHistory.length,
      hasEmail: !!email 
    });
    
    // Получение IP клиента
    const clientIP = getClientIP();
    console.log('[checkOrder] Client IP:', clientIP);
    
    // Проверка rate limit
    try {
      const limitInfo = rateLimiter.checkLimit(clientIP, 5, 15 * 60 * 1000); // 5 попыток в 15 минут
      console.log(`[checkOrder] Rate limit check passed. Remaining: ${limitInfo.remaining}`);
    } catch (limitError) {
      console.error('[checkOrder] Rate limit error:', limitError.message);
      if (limitError.message === 'RATE_LIMIT_EXCEEDED') {
        throw new Error('RATE_LIMIT_EXCEEDED');
      }
      if (limitError.message === 'IP_BLOCKED') {
        throw new Error('IP_BLOCKED');
      }
      throw limitError;
    }

    // Проверяем, был ли заказ уже восстановлен (в истории) - только для информации
    const existingOrder = existingHistory.find(item => item.orderNumber === v_o_id);
    const wasAlreadyRestored = !!existingOrder;
    
    if (wasAlreadyRestored) {
      console.log('[checkOrder] Заказ уже был восстановлен ранее:', {
        orderNumber: v_o_id,
        previousTimestamp: existingOrder.timestamp,
        previousSubscription: existingOrder.subscription ? '***EXISTS***' : 'NONE'
      });
      console.log('[checkOrder] Вызываем API для получения актуальной подписки...');
    } else {
      console.log('[checkOrder] Заказ новый, вызываем API...');
    }

    // Валидация номера заказа
    if (!v_o_id || !v_o_id.trim()) {
      console.error('[checkOrder] Невалидный номер заказа: пустое значение');
      throw new Error('INVALID_ORDER');
    }

    const trimmedOrderId = v_o_id.trim();
    console.log('[checkOrder] Валидация номера заказа:', trimmedOrderId);
    
    // Проверяем формат номера заказа (должен быть числовой)
    if (!/^\d+$/.test(trimmedOrderId)) {
      console.error('[checkOrder] Невалидный формат: не числовой');
      throw new Error('INVALID_ORDER');
    }

    // Дополнительная валидация формата номера заказа
    if (trimmedOrderId.length < 10 || trimmedOrderId.length > 12) {
      console.error('[checkOrder] Невалидная длина:', trimmedOrderId.length);
      throw new Error('INVALID_ORDER_FORMAT');
    }

    // Отправляем запрос к реальному API
    console.log('[checkOrder] Отправка запроса к API:', {
      url: API_BASE,
      method: 'POST',
      orderNumber: trimmedOrderId
    });
    
    const apiRequestStart = Date.now();
    const response = await fetch(API_BASE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        v_o_id: trimmedOrderId
      })
    });
    
    const apiRequestDuration = Date.now() - apiRequestStart;
    console.log('[checkOrder] API ответ получен:', {
      status: response.status,
      statusText: response.statusText,
      duration: `${apiRequestDuration}ms`
    });

    // Проверяем статус ответа
    if (!response.ok) {
      const errorText = await response.text();
      console.error('[checkOrder] API HTTP Error:', {
        status: response.status,
        statusText: response.statusText,
        errorText: errorText.substring(0, 200) // Первые 200 символов
      });
      
      // Пытаемся парсить JSON ошибки для PostgREST
      let errorData = null;
      try {
        errorData = JSON.parse(errorText);
      } catch (parseError) {
        // Если не удалось парсить JSON, используем текст как есть
      }     
      // Обрабатываем различные HTTP статусы
      if (response.status === 404) {
        // Проверяем, это ли ошибка PostgREST о функции
        if (errorData && errorData.code === 'PGRST202') {
          throw new Error('FUNCTION_NOT_FOUND');
        }
        throw new Error('ORDER_NOT_FOUND');
      } else if (response.status === 400) {
        throw new Error('INVALID_ORDER');
      } else if (response.status >= 500) {
        throw new Error('SERVER_ERROR');
      } else {
        throw new Error('API_ERROR');
      }
    }

    // Парсим ответ
    let data;
    const responseText = await response.text();
    console.log('[checkOrder] API Response (raw):', {
      length: responseText.length,
      preview: responseText.substring(0, 200)
    });
    
    try {
      data = JSON.parse(responseText);
      console.log('[checkOrder] API Response (parsed JSON):', { 
        isNull: data === null,
        isObject: data !== null && typeof data === 'object',
        subscription_url: data?.subscription_url ? '***HIDDEN***' : undefined,
        hasOrderDate: !!data?.order_date,
        hasStatus: !!data?.status
      });
    } catch (parseError) {
      // Если не удалось парсить JSON, возможно это строка
      console.warn('[checkOrder] Не удалось распарсить JSON ответ:', parseError.message);
      console.log('[checkOrder] API Response (Text):', responseText);
      
      // Обрабатываем текстовые ответы
      if (responseText === '"Ключ по ордеру уже менялся"' || responseText === 'Ключ по ордеру уже менялся') {
        throw new Error('KEY_ALREADY_CHANGED');
      } else if (responseText.includes('не найден') || responseText.includes('not found')) {
        throw new Error('ORDER_NOT_FOUND');
      } else if (responseText.includes('недействителен') || responseText.includes('invalid')) {
        throw new Error('INVALID_ORDER');
      }
      
      throw new Error('INVALID_RESPONSE');
    }
  
    
    // Если API вернул null — это некорректный ответ
    if (data === null) {
      console.warn('[checkOrder] API вернул null');
      throw new Error('INVALID_RESPONSE');
    }
    
    // Проверяем структуру ответа
    console.log('[checkOrder] Data after JSON parse:', {
      type: typeof data,
      isObject: typeof data === 'object',
      isNull: data === null,
      keys: typeof data === 'object' && data !== null ? Object.keys(data) : 'N/A'
    });
    
    // Если ответ - это строка, обрабатываем как текстовый ответ
    if (typeof data === 'string') {
      console.log('[checkOrder] API Response is string after JSON parse:', data);
      
      // Проверяем, является ли строка JSON объектом в кавычках
      if (data.startsWith('{') && data.endsWith('}')) {
        try {
          console.log('[checkOrder] Attempting to parse string as JSON object');
          data = JSON.parse(data);
          console.log('[checkOrder] Successfully parsed string as JSON:', {
            ...data,
            subscription_url: data.subscription_url ? '***HIDDEN***' : undefined
          });
        } catch (parseError) {
          console.error('[checkOrder] Failed to parse string as JSON:', parseError.message);
        }
      }
      
      // Если после попытки парсинга data всё ещё строка, обрабатываем как текстовые ответы
      if (typeof data === 'string') {
        // Обрабатываем текстовые ответы
        if (data === '"Ключ по ордеру уже менялся"' || data === 'Ключ по ордеру уже менялся') {
          throw new Error('KEY_ALREADY_CHANGED');
        } else if (data.includes('не найден') || data.includes('not found')) {
          throw new Error('ORDER_NOT_FOUND');
        } else if (data.includes('недействителен') || data.includes('invalid')) {
          throw new Error('INVALID_ORDER');
        }
        
        throw new Error('INVALID_RESPONSE');
      }
    }
    
    if (!data || typeof data !== 'object' || data === null) {
      console.error('[checkOrder] API Response is not valid object:', {
        data: data,
        type: typeof data,
        isNull: data === null
      });
      throw new Error('INVALID_RESPONSE');
    }

    // Проверяем наличие подписки в ответе
    console.log('[checkOrder] Checking subscription_url:', {
      exists: !!data.subscription_url,
      type: typeof data.subscription_url,
      value: data.subscription_url ? '***HIDDEN***' : 'undefined'
    });
    
    if (!data.subscription_url) {
      console.error('[checkOrder] API Response missing subscription_url:', {
        availableKeys: Object.keys(data),
        data: data
      });
      throw new Error('NO_SUBSCRIPTION');
    }

    // Валидируем URL подписки
    const subscriptionUrl = data.subscription_url.trim();
    console.log('[checkOrder] Validating subscription URL:', {
      urlLength: subscriptionUrl.length,
      urlStart: subscriptionUrl.substring(0, 50) + '...'
    });
    
    try {
      const url = new URL(subscriptionUrl);
      console.log('[checkOrder] URL validation successful:', {
        protocol: url.protocol,
        hostname: url.hostname,
        pathnameLength: url.pathname.length
      });
    } catch (urlError) {
      console.error('[checkOrder] URL validation failed:', {
        error: urlError.message,
        url: subscriptionUrl.substring(0, 100)
      });
      throw new Error('INVALID_SUBSCRIPTION_URL');
    }

    // Формируем результат
    const result = {
      orderNumber: trimmedOrderId,
      orderDate: data.order_date || new Date().toLocaleDateString('ru-RU'),
      status: data.status || 'Обработан',
      subscription: subscriptionUrl,
      isAlreadyRestored: false
    };
    
    console.log('[checkOrder] Результат сформирован:', {
      orderNumber: result.orderNumber,
      orderDate: result.orderDate,
      status: result.status,
      subscription: '***HIDDEN***',
      isAlreadyRestored: result.isAlreadyRestored
    });

    // Увеличиваем счетчик замененных ключей в Firebase
    try {
      console.log('[checkOrder] Обновление статистики в Firebase...');
      await chatService.incrementKeyReplacements();
      // Отправляем глобальное уведомление всем пользователям
      await chatService.sendGlobalSuccessNotification(trimmedOrderId);
      console.log('[checkOrder] Статистика обновлена успешно');
      
      // Если указан email - сохраняем в Firebase
      if (email && email.trim()) {
        console.log('[checkOrder] Сохранение email подписки...');
        await chatService.saveEmailSubscription(trimmedOrderId, email.trim(), subscriptionUrl);
        result.emailSent = true;
        console.log('[checkOrder] Email подписка сохранена');
      }
    } catch (statsError) {
      console.error('[checkOrder] Ошибка обновления статистики:', statsError);
      // Не прерываем выполнение при ошибке статистики
    }

    console.log('[checkOrder] ✅ Успешно завершено:', { 
      orderNumber: result.orderNumber,
      subscription: '***HIDDEN***',
      isAlreadyRestored: result.isAlreadyRestored,
      emailSent: result.emailSent || false
    });
    
    return result;

  } catch (error) {
    console.error('[checkOrder] ❌ Ошибка при проверке заказа:', {
      message: error.message,
      stack: error.stack,
      orderNumber: v_o_id
    });

    // Перебрасываем ошибку для обработки в UI — без фолбэков
    if (error.message === 'ORDER_NOT_FOUND' || 
        error.message === 'INVALID_ORDER' || 
        error.message === 'SERVER_ERROR' ||
        error.message === 'API_ERROR' ||
        error.message === 'INVALID_RESPONSE' ||
        error.message === 'NO_SUBSCRIPTION' ||
        error.message === 'INVALID_SUBSCRIPTION_URL' ||
        error.message === 'FUNCTION_NOT_FOUND' ||
        error.message === 'KEY_ALREADY_CHANGED' ||
        error.message === 'RATE_LIMIT_EXCEEDED' ||
        error.message === 'IP_BLOCKED') {
      throw error;
    }

    // Для неизвестных ошибок
    console.error('[checkOrder] Неизвестная ошибка, преобразование в UNKNOWN_ERROR');
    throw new Error('UNKNOWN_ERROR');
  }
};

// API функция для получения статистики (для будущего использования)
export const getStats = async () => {
  await new Promise(resolve => setTimeout(resolve, 500));
  
  return {
    totalOrders: 0, // Будет получаться из реального API
    processedToday: Math.floor(Math.random() * 50) + 10,
    successRate: 98.5
  };
};

// API функция для валидации номера заказа
export const validateOrderNumber = (orderNumber) => {
  if (!orderNumber || !orderNumber.trim()) {
    return { valid: false, message: 'Введите номер заказа' };
  }
  
  const trimmed = orderNumber.trim();
  
  if (trimmed.length < 5) {
    return { valid: false, message: 'Номер заказа должен содержать минимум 5 цифр' };
  }
  
  if (!/^\d+$/.test(trimmed)) {
    return { valid: false, message: 'Номер заказа должен содержать только цифры' };
  }
  
  if (trimmed.length > 20) {
    return { valid: false, message: 'Номер заказа слишком длинный' };
  }
  
  return { valid: true };
};
